let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("ffQaD"), load("kvRbA"), load("3Lctm")]).then(() => parcelRequire('6Fxr4'));